import * as turf from "@turf/turf"

export function sanitizeData(data) {
    if (!data) {
        return null
    }

    const dataFeatures = []
    turf.geomEach(data, (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) => {
        const feature = data.features[featureIndex]
        const linearLocation = feature.linear_location ?? feature.linearLocation
        const subNetworkSlugs = feature.sub_network_slugs ?? feature.subNetworkSlugs
        dataFeatures.push({
            bbox: featureBBox,
            geometry: currentGeometry,
            id: featureId,
            properties: {
                ...transformSnakeCase(featureProperties),
                linearLocation: Array.isArray(linearLocation) ? linearLocation : [linearLocation],
                subNetworkSlugs: subNetworkSlugs,
                uuid: featureId,
            },
        })
    })

    return turf.featureCollection(dataFeatures)
}

export function filterFeaturesByRoad(featureCollection, road) {
    const dataFeatures = []
    turf.geomEach(featureCollection, (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) => {
        const feature = featureCollection.features[featureIndex]
        const linearLocation = feature.linear_location[0]
        if (linearLocation.road !== road) {
            return
        }

        dataFeatures.push({
            bbox: featureBBox,
            geometry: currentGeometry,
            id: featureId,
            properties: {
                ...transformSnakeCase(featureProperties),
                linearLocation: Array.isArray(feature.linear_location) ? feature.linear_location : [feature.linear_location],
                uuid: featureId,
            },
        })
    })

    return turf.featureCollection(dataFeatures)
}

function transformSnakeCase(featureProperties) {
    return Object.entries(featureProperties).reduce((acc, [k, v]) => ({
        ...acc,
        [snakeToCamel(k)]: v,
    }), {})
}


function snakeToCamel(snake_str) {
    return snake_str.replace(/(_\w)/g, function (match) {
        return match[1].toUpperCase()
    })
}